
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cupons/novo-cupom",
      function () {
        return require("private-next-pages/cupons/novo-cupom.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cupons/novo-cupom"])
      });
    }
  